<script type="text/javascript">
import Modal from 'Components/global/Modal.vue';
import TextareaAutosize from 'Components/global/form/TextareaAutosize.vue';
import DatePicker from 'Components/global/form/DatePicker.vue';

export default {
    props: {
        isOpen: {
            type: Boolean,
            required: true,
            default: false,
        },
        reason: {
            type: String,
            required: true,
            default: '',
        },
    },

    methods: {
        reasonUpdated(newValue) {
            this.$emit('reasonUpdated', newValue);
        },
    },

    components: {
        DatePicker,
        Modal,
        TextareaAutosize,
    },
};
</script>

<template>
    <div>
        <modal :value="isOpen" @input="newValue => $emit('openToggled', newValue)" class="text-left">
            <template #title>
                <div v-if="$slots.title">
                    <slot name="title" />
                </div>

                <div v-else>
                    {{ trans('settings.statuses.modal.default_title') }}
                </div>
            </template>

            <template #default>
                <div v-if="$slots.confirmation" class="mb-6 mt-0">
                    <slot name="confirmation" />
                </div>

                <form>
                    <div class="form-group mt-2" :class="{ 'has-error': errors.has('reason') }">
                        <label for="reason" class="control-label">
                            {{ trans('documents.document_add_reason_description') }}
                        </label>

                        <textarea-autosize
                            id="reason"
                            rows="6"
                            class="form-control m-b-0"
                            :value="reason"
                            @input="newValue => reasonUpdated(newValue)"
                            :placeholder="trans('documents.document_add_reason_placeholder')"
                            style="min-height: 80px"
                        />

                        <div v-show="errors.has('reason')" class="help-block">
                            {{ errors.first('reason') }}
                        </div>
                    </div>
                </form>
            </template>

            <template #footer>
                <slot name="footer" />
            </template>
        </modal>
    </div>
</template>
